export const Checked = () => {
	/*********************
	// #region Redux
	**********************/
	return (
		<img src={process.env.VITE_CHECK_IMAGE} className='w-6'/>
	);
};
